export default __webpack_public_path__ + "e3df30219214ca420dfa155e0a5b7675.png";